export default __webpack_public_path__ + "static/media/xls.77edaf8a.svg";